import { AccordionProps as MuiAccordionProps } from '@mui/material';
import { ReactNode } from 'react';

// Constants for default messages
export const ACCORDION_CONSTANTS = {
  EMPTY_HEADER: 'Empty Accordion',
  NO_CONTENT_AVAILABLE: 'No content available',
} as const;

export interface AccordionProps extends Omit<MuiAccordionProps, 'children'> {
  /**
   * Content to be rendered inside the accordion body
   */
  children?: ReactNode;
  /**
   * Custom header component that gives parent full control over header layout and content.
   */
  header?: ReactNode;
}
